import { useState } from 'react';

import {
  allocationColDef,
  indicationColDef,
  investorCountColDef,
  issuerColDef,
  lastUpdatedAtColDef,
  lastUploadedAtColDef,
  offeringTypeColDef,
  pricingDateColDef,
  reviewStatusColDef,
  symbolColDef,
  updatedByColDef,
  uploadedByColDef,
} from './column-definitions';
import { ParticipationSetsGridColDef } from './types';

export const useCreateColumnDefs = () => {
  const [colDefs] = useState<ParticipationSetsGridColDef[]>([
    pricingDateColDef,
    issuerColDef,
    symbolColDef,
    offeringTypeColDef,
    investorCountColDef,
    reviewStatusColDef,
    allocationColDef,
    indicationColDef,
    lastUploadedAtColDef,
    uploadedByColDef,
    lastUpdatedAtColDef,
    updatedByColDef,
  ]);

  return colDefs;
};
